<template>
    <div>
      <h4 class="mt-4 mb-2 fs-16 dkl-h4">Dateien</h4>
      <div class="card mb-2 shadow-none border" v-for="file in commentObject.attachments" :key="'file-'+ file.id">
        <div class="p-1 px-2">
          <div class="row align-items-center">
            <div class="col ps-0">
              <a :href="file.file_url" class="text-muted fw-bold">{{file.name}}</a>
              <p class="mb-0">{{file.size}}</p>
            </div>
            <div class="col-auto">
              <a href="#" title="Delete" class="btn btn-link text-danger btn-lg p-0" @click.prevent="deleteFile(file.id)">
                <i class="fa fa-trash"  :data-file-id="file.id"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="p-1 px-2" v-if="commentObject.id && edit">
        <div class="row align-items-center">
          <van-uploader :after-read="(file) => uploadFile(commentObject.id, file)">
            <van-button icon="plus" type="primary" size="small">Upload Datei</van-button>
          </van-uploader>
        </div>
      </div>
      <div class="p-1 px-2" v-else-if="!commentObject.id">
        <p>Der neue {{ modelVerboseName }} muss erst gespeichert werden bevor Dateien hochgeladen werden können!</p>
      </div>
    </div>
</template>

<script>
  import {mapState} from 'vuex';
  import service from '@/utils/request.js';
  import { Uploader, Button } from 'vant';
    export default {
      name: "FileUploadComponent",
      components: {'van-uploader': Uploader, 'van-button': Button},
      props: {
        commentObject: {
          type: Object,
          required: true,
          default: () => {
            return {
              id: null,
              comments: [],
            }
          }
        },
        modelName: {
          type: String,
          required: true
        },
        modelVerboseName: {
          type: String,
          default: 'Eintrag'
        }
      },
      data() {
        return {
          newComment: ''
        }
      },
      computed: {
        ...mapState({user: state => state.user, account: state => state.account, edit: state => state.app.edit}),
      },
      methods: {
        deleteFile(fileID) {
          service.request({
            url: `todos/v1/delete_attachment/${fileID}/`,
            method: 'DELETE',
            responseType: 'json',
          }).then((response) => {
            const fileIndex = this.commentObject.attachments.findIndex((attachment) => attachment.id === fileID)
            this.commentObject.attachments.splice(fileIndex, 1)
            this.$emit('attachmentUpdated', this.commentObject)
          })
        },
        uploadFile(id, file) {
          const formData = new FormData();
          formData.append('file', file.file);
          formData.append('modified_by', this.user.username);
          formData.append('model', this.modelName);
          formData.append('object_id', id);
          service.request({
            url: 'todos/v1/save_attachment/',
            method: 'post',
            data: formData,
            contentType: false,
            processData: false
          }).then((response) => {
            this.commentObject.attachments.push(response.data)
            this.$emit('attachmentUpdated', this.commentObject)
          })
        },
      }
    }
</script>

<style scoped>

</style>
